<!-- eslint-disable max-len -->
<template>
  <Stack class="completion-and-thanks">
    <Stack
      class="completion-content"
      items="center"
    >
      <Stack
        gap="4"
        items="center"
      >
        <Title
          class="success-title"
          size="8"
        >
          Client Portal not available
        </Title>
      </Stack>

      <p class="success-message">
        Your financial advisor <strong>{{ clientPortalStore.advisorName }}</strong> has not enabled your Client Portal.
      </p>

      <p class="success-info">
        If you have any questions,
        don't hesitate to contact
        <span v-if="clientPortalStore.advisorInfo?.email">
          them at <a :href="mailto">{{ clientPortalStore.advisorInfo.email }}</a>.
        </span>
        <span v-else>
          them.
        </span>
      </p>
    </Stack>
  </Stack>
</template>

<script setup>
import { computed } from 'vue';
import { Stack, Title } from '@stakeui';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const clientPortalStore = useClientPortalStore();

const mailto = computed(() => `mailto:${clientPortalStore.advisorInfo?.email}`);
</script>

<style scoped>
.completion-and-thanks {
  background-color: #fff;
  max-width: 50rem;
  margin: 0 auto;
  text-align: center;
  padding: 4em 3em;
  border-radius: 2em;
  box-shadow: 0px 32px 32px 0px rgba(0, 0, 0, 0.02), 0px 16px 16px 0px rgba(0, 0, 0, 0.02), 0px 8px 8px 0px rgba(0, 0, 0, 0.02), 0px 4px 4px 0px rgba(0, 0, 0, 0.02), 0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.02);
}

.success-message {
  max-width: 20em;
  font-size: 1.25em;
}

.success-info {
  color: var(--stk-text-50);
}
</style>
